import CalendarActionResponse from 'owa-service/lib/contract/CalendarActionResponse';
import itemId from 'owa-service/lib/factory/itemId';
import setCalendarHexColorOperation from 'owa-service/lib/operation/setCalendarHexColorOperation';
import { CalendarId } from 'owa-calendar-cache';
import { getMailboxRequestOptions } from 'owa-request-options-types';

/**
 * sets calendar hex color on server
 * @param id id of the calendar that needs to be deleted
 * @param changeKey the change key for the id
 * @param calendarColor the calendar color to set
 */
export default async function setCalendarHexColorService(
    calendarId: CalendarId,
    changeKey: string,
    calendarColor: string
): Promise<CalendarActionResponse> {
    let hexInt = 0;

    // Expected format is "#rrggbb"
    let validation = new RegExp('^#[0-9a-f]{6}$', 'gi');
    if (!validation.exec(calendarColor)) {
        return {
            WasSuccessful: false,
        };
    }

    let parts: string[] = calendarColor.split('#').filter(option => !!option);
    if (parts.length == 1) {
        hexInt = parseInt(parts[0], 16);

        // Google's colors have alpha=0 which in Exchange is reserved for automatic color assignment.
        // Set it to a non-zero value when converting to Exchange's representation.
        hexInt |= 0xff000000;
    }

    return setCalendarHexColorOperation(
        {
            itemId: itemId({ Id: calendarId.id, ChangeKey: changeKey }),
            hexColor: hexInt,
        },
        getMailboxRequestOptions(calendarId.mailboxInfo)
    );
}
